import React, { useState, useCallback } from 'react';
import { Tab } from 'semantic-ui-react';

import GuaranteePurchases from './GuaranteePurchases';
import CancelledGuaranteePurchases from './CancelledGuaranteePurchases';
import IneligiblePurchases from './IneligiblePurchases';
import GuaranteeProductSelector from '../components/GuaranteeProductSelector';
import GuaranteePanel from '../components/GuaranteePanel';
import useFeatureFlag from '../hooks/useFeatureFlag';
import { DB_GUARANTEES_V2 } from '../constants/featureFlags';
import { useGuaranteeTheme } from '../hooks/useGuaranteePurchases';

// The product selector only applies to the Ineligible tab; on the other tabs the panel
// keeps its space in the layout but is hidden entirely (see GuaranteePanel).
const PRODUCT_SELECTOR_TAB_KEY = 'ineligible';

const GuaranteePurchasesTabs = () => {
  const [isGuaranteesV2Enabled, loaded] = useFeatureFlag(DB_GUARANTEES_V2);
  const themeClass = useGuaranteeTheme();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = useCallback((e, { activeIndex }) => {
    setActiveTabIndex(activeIndex);
  }, []);

  // Wait for flags so we don't flash the V1 layout before switching to V2.
  if (!loaded) return null;

  if (!isGuaranteesV2Enabled) {
    const panes = [
      {
        menuItem: { key: 'guarantee', content: 'Guarantee Purchases', 'data-testid': 'tab-guarantee' },
        render: () => (
          <Tab.Pane>
            {' '}
            <GuaranteePurchases />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: 'cancelled', content: 'Canceled Purchases', 'data-testid': 'tab-cancelled' },
        render: () => (
          <Tab.Pane>
            <CancelledGuaranteePurchases />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div data-testid='guarantees-tabs'>
        {' '}
        <Tab panes={panes} />
      </div>
    );
  }

  const panes = [
    {
      menuItem: { key: 'guarantee', content: 'Guarantee Purchases', 'data-testid': 'tab-guarantee' },
      render: () => (
        <Tab.Pane>
          <GuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'cancelled', content: 'Cancelled Purchases', 'data-testid': 'tab-cancelled' },
      render: () => (
        <Tab.Pane>
          <CancelledGuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'ineligible', content: 'Ineligible Purchases', 'data-testid': 'tab-ineligible' },
      render: () => (
        <Tab.Pane>
          <IneligiblePurchases />
        </Tab.Pane>
      ),
    },
  ];

  const isProductSelectorTab = panes[activeTabIndex]?.menuItem.key === PRODUCT_SELECTOR_TAB_KEY;

  return (
    <div
      data-testid='guarantees-tabs'
      style={{ marginTop: '-56px' }}
      className={themeClass}
    >
      <GuaranteePanel isHidden={!isProductSelectorTab}>
        <GuaranteeProductSelector />
      </GuaranteePanel>
      <Tab
        panes={panes}
        activeIndex={activeTabIndex}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default GuaranteePurchasesTabs;
